var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"duplicate-candidate-icon"},[_c('i',{staticClass:"iconfont icona-bianzu53 background",style:(_vm.backGroundStyle)}),_c('i',{staticClass:"iconfont iconexclamation-sign dot",class:_vm.dotPosition,style:(_vm.dotStyle)})])
}
var staticRenderFns = []

export { render, staticRenderFns }